'use strict';
(function () {
  angular.module('pentaApp').factory('clubRules.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/clubRules');
  }
})();
